import React from 'react';
import { motion } from 'framer-motion';
import IntegrationList from './components/IntegrationList/IntegrationList';
import { useTranslation } from 'react-i18next';

const Integracoes: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="p-6 lg:p-10 max-w-4xl mx-auto flex flex-col gap-8"
    >
      <div className="flex flex-col gap-2 text-center">
        <motion.h1 
          className="text-4xl font-black leading-tight tracking-[-0.033em]"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.6 }}
        >
          <span className="gradient-text">{t('integrations.title')}</span>
        </motion.h1>
        <motion.p 
          className="text-lg text-gray-600 dark:text-gray-400"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          {t('integrations.subtitle')}
        </motion.p>
      </div>
      
      <IntegrationList />
    </motion.div>
  );
};

export default Integracoes;